// extracted by mini-css-extract-plugin
module.exports = {"controlsContainer":"style_controlsContainer__1AjYw","button":"style_button__2Df9O","positiveButton":"style_positiveButton__16PY-","negativeButton":"style_negativeButton__2aYFZ"};